@if (processState()) {
  <div class="process-state-container">
    <div
      class="process-state-container"
      [matTooltip]="processState().description"
      matTooltipPosition="below"
      (dblclick)="this.navigateToRelatedRecord.emit(processState())">
      <div
        class="basic-grid-button current-content"
        [style]="{'border': getStateBorder(processState()), 'color': getStateColor(processState())}"
        >
        <app-icon [icon]="processState().icon" />
        <span class="state-text no-wrap">{{ processState().label ?? '' }}</span>
      </div>
    </div>
    @if (processState()?.transitions?.length > 0) {
      <div>
        <div class="next-line"  [style]="{'color': getStateColor(processState())}"></div>
      </div>
    }
    @for (transition of processState().transitions; track transition.id) {
      <button
        mat-button
        [matTooltip]="transition?.label"
        matTooltipPosition="below"
        id="{{ transition.id }}"
        class="basic-grid-button"
        [style]="{'border': getStateBorder(transition, true), 'color': getStateColor(transition, true)}"
        (click)="executeTransition(transition.targetStateId)">
        <app-icon [icon]="transition.icon" />
        <span class="transition-text no-wrap" [style.max-width]="transition.icon ? '80%' : '100%'">{{
          transition?.label
        }}</span>
      </button>
    }
  </div>
}
